export default "__VITE_ASSET__5a277e15__"